// WorkforceDiversity.js
import React from 'react';
import { Bar } from '@ant-design/plots';

const WorkforceDiversity = () => {
  // Define the data for the bar chart
  const data = [
    { year: '2019', male: 1520, female: 320, minority: 200, minorityPercentage: 0 },
    { year: '2020', male: 1500, female: 300, minority: 250, minorityPercentage: 0 },
    { year: '2021', male: 1450, female: 350, minority: 300, minorityPercentage: 5 }, // Dummy data for 2021
    { year: '2022', male: 1400, female: 400, minority: 400, minorityPercentage: 7 }, // Dummy data for 2022
  ];

  // Transform the data to fit the bar chart format
  const transformedData = data.flatMap(item => [
    { year: item.year, category: 'Number of Male Employees', value: item.male },
    { year: item.year, category: 'Number of Female Employees', value: item.female },
    { year: item.year, category: 'Number of Minority Employees', value: item.minority },
    { year: item.year, category: '% Workforce of Minority Groups', value: item.minorityPercentage },
  ]);

  // Configuration for the bar chart
  const config = {
    theme: "classicDark",
    height: 200,
    data: transformedData,
    xField: 'year',
    yField: 'value',
    colorField: 'category',
    isGroup: true, // Group the bars by year
    style: {
      inset: 5,
    },
    meta: {
      year: {
        alias: 'Year',
      },
      value: {
        alias: 'Count',
      },
      category: {
        alias: 'Category',
      },
    },
    tooltip: {
      title: (title) => `Year: ${title}`,
      items: [{ name: 'Count', value: '' }],
    },
  };

  return <Bar {...config} />;
};

export default WorkforceDiversity;
